<h2 mat-dialog-title class="pwa-update-dialog__title">
    {{ data.required ? 'Требуется перезагрузка' : 'Доступно обновление' }}
</h2>

<div mat-dialog-content class="pwa-update-dialog__content">
    <p *ngIf="data.required; else regularUpdateMessage">
        Текущая версия приложения больше не может продолжить работу. Перезагрузите
        страницу, чтобы восстановить приложение.
    </p>

    <ng-template #regularUpdateMessage>
        <p>Новая версия приложения загружена и готова к установке.</p>
    </ng-template>

    <div
        class="pwa-update-dialog__versions"
        *ngIf="data.currentVersion || data.latestVersion"
    >
        <span *ngIf="data.currentVersion">
            Текущая: {{ data.currentVersion }}
        </span>
        <span *ngIf="data.latestVersion">
            Новая: {{ data.latestVersion }}
        </span>
    </div>
</div>

<div mat-dialog-actions class="pwa-update-dialog__actions">
    <button
        *ngIf="!data.required"
        type="button"
        class="pwa-update-dialog__later"
        [mat-dialog-close]="false"
    >
        Позже
    </button>
    <button
        type="button"
        class="pwa-update-dialog__update"
        [mat-dialog-close]="true"
    >
        {{ data.required ? 'Перезагрузить' : 'Обновить' }}
    </button>
</div>
